import { createFileRoute, Link } from "@tanstack/react-router";
import { Image } from "@/components/image";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { ACTIVITIES__NEW__ } from "@/lib/constants";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/buchen/")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Buchen – Alte Papierfabrik Wuppertal",
      description:
        "Jetzt Bowling oder 3D-Schwarzlicht Minigolf in der Alten Papierfabrik Wuppertal online buchen.",
      path: "/buchen",
    }),
});

function RouteComponent() {
  return (
    <ScaffoldSection className="md:pt-24">
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Buchen</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent className="mx-auto grid max-w-2xl grid-cols-2 gap-4 md:grid-cols-3">
          {Object.values(ACTIVITIES__NEW__)
            .filter((a) => "bookingLink" in a)
            .map((activity) => (
              <Link
                {...activity.bookingLink}
                className="grid gap-2"
                key={activity.key}
              >
                <div className="relative flex aspect-square items-center justify-center overflow-hidden rounded-lg">
                  <Image
                    alt={activity.name}
                    className="absolute inset-0 size-full object-cover object-center"
                    height={180}
                    src={activity.brand.backgroundImage}
                    width={180}
                  />
                  <div className="absolute inset-0 bg-black/50" />
                  <Image
                    alt={activity.name}
                    className="relative size-3/5 object-contain object-center"
                    height={110}
                    src={activity.brand.logo}
                    width={110}
                  />
                </div>
              </Link>
            ))}
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
